import { useState, useRef, useCallback } from 'react'
import { deepEqual } from '@/shared/utils/deepEqual'

/**
 * Stable data store for map data (waypoints, routes)
 * Only updates when data actually changes (deep equality check)
 * Prevents unnecessary layer updates and re-renders
 */
export function useMapDataStore() {
  const waypointsRef = useRef<any[]>([])
  const routesRef = useRef<any[]>([])
  
  const [waypoints, setWaypoints] = useState<any[]>([])
  const [routes, setRoutes] = useState<any[]>([])
  
  // Only update if data actually changed (deep equality)
  // Validates input to prevent undefined/null updates
  const updateWaypoints = useCallback((newWaypoints: any[]) => {
    // Validation: ensure newWaypoints is a valid array
    if (!Array.isArray(newWaypoints)) {
      return
    }
    
    // Only update if data actually changed (deep equality)
    const hasChanged = !deepEqual(waypointsRef.current, newWaypoints)
    
    if (hasChanged) {
      waypointsRef.current = newWaypoints
      setWaypoints(newWaypoints)
    }
  }, [])
  
  const updateRoutes = useCallback((newRoutes: any[]) => {
    // Validation: ensure newRoutes is a valid array
    if (!Array.isArray(newRoutes)) {
      return
    }
    
    // Only update if data actually changed (deep equality)
    if (!deepEqual(routesRef.current, newRoutes)) {
      routesRef.current = newRoutes
      setRoutes(newRoutes)
    }
  }, [])
  
  return {
    waypoints,
    routes,
    updateWaypoints,
    updateRoutes,
    waypointsRef,
    routesRef
  }
}

